module.exports = __webpack_public_path__ + "img/homegray.512833a3.svg";